import { render, staticRenderFns } from "./HistoryChat.vue?vue&type=template&id=2b7da016"
import script from "./HistoryChat.vue?vue&type=script&lang=js"
export * from "./HistoryChat.vue?vue&type=script&lang=js"
import style0 from "./HistoryChat.vue?vue&type=style&index=0&id=2b7da016&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports